import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(err, info) {
    // 上报到控制台，避免整站白屏时无痕
    // eslint-disable-next-line no-console
    console.error('[UI ErrorBoundary]', err, info?.componentStack);
  }

  handleReload = () => {
    try { window.location.reload(); } catch (_) { /* noop */ }
  };

  handleGoHome = () => {
    try { window.location.hash = '#/'; window.location.reload(); } catch (_) { /* noop */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: '100vh',
          background: '#0b0d12',
          color: '#e6e6e6',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px'
        }}
      >
        <div style={{ maxWidth: 480, textAlign: 'center' }}>
          <div style={{ fontSize: 44, marginBottom: 12 }}>⚠️</div>
          <h2 style={{ margin: '0 0 12px', color: '#f2c34a' }}>Something went wrong</h2>
          <p style={{ color: '#9aa0a6', marginBottom: 20, lineHeight: 1.6 }}>
            The page failed to render. This is usually a temporary issue. Please refresh, or go back to home.
          </p>
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
            <button
              onClick={this.handleReload}
              style={{
                padding: '10px 18px',
                background: '#f2c34a',
                color: '#0b0d12',
                border: 'none',
                borderRadius: 6,
                fontWeight: 600,
                cursor: 'pointer'
              }}
            >
              Refresh
            </button>
            <button
              onClick={this.handleGoHome}
              style={{
                padding: '10px 18px',
                background: 'transparent',
                color: '#e6e6e6',
                border: '1px solid #33383f',
                borderRadius: 6,
                cursor: 'pointer'
              }}
            >
              Go Home
            </button>
          </div>
          {process.env.NODE_ENV !== 'production' && this.state.err && (
            <pre style={{
              marginTop: 20,
              background: '#111418',
              color: '#ff8080',
              padding: 12,
              borderRadius: 6,
              textAlign: 'left',
              maxHeight: 200,
              overflow: 'auto',
              fontSize: 12
            }}>
              {String(this.state.err && (this.state.err.stack || this.state.err.message || this.state.err))}
            </pre>
          )}
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
